import { render, staticRenderFns } from "./inbound-calls.vue?vue&type=template&id=1863c5f1&"
import script from "./inbound-calls.vue?vue&type=script&lang=js&"
export * from "./inbound-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports